<template>
  <div class="w-screen h-screen flex flex-col">
    <c_header></c_header>
    <div class="flex-1 flex flex-col overflow-hidden p-2 bg-gray-100">
      <div class="px-2 gap-x-3 overflow-hidden flex items-center">
        <div
          class="w-5 border-r h-3 flex items-center"
          v-if="state.show_tag_care"
        >
          <el-icon
            class="cursor-pointer hover:text-primary"
            @click.stop="onChangeScroll(1)"
            @dblclick.stop=""
            ><CaretLeft
          /></el-icon>
        </div>
        <div
          ref="tagDom"
          class="flex flex-1 index-tag items-center overflow-x-auto"
        >
          <div class="flex index-tag-box">
            <template
              v-for="(item, index) in $store.state.nav_list"
              :key="item"
            >
              <li
                class="py-2 px-4 text-xs rounded-t-lg cursor-pointer flex items-center gap-x-2 text-gray-500 whitespace-nowrap"
                :class="
                  $store.state.nav_index == index
                    ? 'bg-white font-bold'
                    : 'nav-hover'
                "
                :style="{
                  color:
                    $store.state.nav_index == index
                      ? 'var(--el-color-primary)'
                      : '',
                }"
                @click="
                  $store.state.nav_index = index;
                  $store.commit('setCurrent');
                  onChangeTab(index);
                "
              >
                <el-icon
                  :size="16"
                  style="margin-bottom: 2px"
                  v-if="index == 0"
                >
                  <HomeFilled />
                </el-icon>
                {{ item.title }}
                <div
                  class="w-3 flex"
                  v-if="index != 0 && $store.state.nav_index == index"
                >
                  <el-icon
                    :size="14"
                    class="rounded-full hover:scale-125"
                    @click.stop="$store.commit('closeMenu', index)"
                  >
                    <Close />
                  </el-icon>
                </div>
              </li>
            </template>
          </div>
        </div>
        <div
          class="w-5 border-l h-3 flex items-center"
          v-if="state.show_tag_care"
        >
          <el-icon
            class="cursor-pointer hover:text-primary"
            @click.stop="onChangeScroll(2)"
            @dblclick.stop=""
            ><CaretRight
          /></el-icon>
        </div>
        <el-button link icon="refresh" @click.stop="$store.commit('refresh')">
          刷新
        </el-button>
        <!-- <el-button
          link
          icon="close"
          @click.stop="$store.commit('closeAll')"
          style="margin-left: -10px"
        >
          全部关闭
        </el-button> -->
        <el-dropdown class="h-full">
          <div
            class="item hover flex items-center outline-none h-full gap-x-1"
            style="color: var(--el-color-font)"
          >
            <el-button
              link
              icon="close"
              @click.stop="$store.commit('closeAll')"
              style="margin-left: -10px"
            >
              全部关闭
            </el-button>
          </div>
          <template #dropdown>
            <el-dropdown-menu
              style="--el-dropdown-menuItem-hover-fill: #f6f6f6"
            >
              <el-dropdown-item @click.stop="$store.commit('closeOther')">
                关闭其他
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div
        class="flex-1 rounded-lg bg-white flex overflow-hidden relative"
        style="margin-top: -1px"
        id="home_box"
      >
        <template v-for="(item, index) in $store.state.nav_list" :key="item">
          <div
            style="animation: fadeIn 0.8s 0.02s ease backwards"
            class="h-full w-full shrink-0 home-content"
            v-show="$store.state.nav_index == index"
            :id="'home_box_' + index"
          >
            <component
              :is="'c_' + item.path"
              :ref="(el) => setItemRef(el, 'comDom' + index)"
              :key="item.key"
              :data="item.data"
            >
            </component>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, onBeforeUnmount } from "vue";
import { home_getuser } from "@/http/home";
import store from "@/store";

import c_header from "./Header.vue";

export default {
  components: {
    c_header,
  },
  setup() {
    const tagDom = ref(null);
    const state = reactive({
      tab_index: 1,
    });
    const comDoms = [];
    const setItemRef = (el, key) => {
      if (el) {
        comDoms[key] = el;
      }
    };
    let observer = null,
      init_width = 0;
    onMounted(() => {
      store.commit("navInit");
      home_getuser().then((res) => {
        if (res.status == 200) {
          store.commit("setLoginUser", res.data.data);
        }
      });

      tagDom.value.addEventListener("wheel", (e) => {
        e.preventDefault(); // 阻止默认垂直滚动
        tagDom.value.scrollLeft += e.deltaY; // 滚轮上下 → 控制左右
      });

      init_width = tagDom.value.clientWidth;

      observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          let tag_width = entry.contentRect.width;
          if (tag_width > init_width) state.show_tag_care = true;
          else state.show_tag_care = false;
        }
      });
      observer.observe(tagDom.value.querySelector(".index-tag-box"));
    });

    onBeforeUnmount(() => {
      if (observer) observer.disconnect();
    });

    const onChangeScroll = (type) => {
      if (type == 1) {
        tagDom.value.scrollLeft -= 100;
      } else {
        tagDom.value.scrollLeft += 100;
      }
    };

    const onChangeTab = (index) => {
      var dom = tagDom.value
        .querySelector(".index-tag-box>li:nth-child(" + (index + 1) + ")")
        .getBoundingClientRect();

      if (dom.x < 100) {
        tagDom.value.scrollLeft += dom.x - 160;
      } else {
        if (dom.width + dom.x > init_width) {
          tagDom.value.scrollLeft += dom.width + dom.x - init_width + 100;
        }
      }
    };

    return { state, setItemRef, tagDom, onChangeScroll, onChangeTab };
  },
};
</script>

<style lang="scss">
.nav-hover:hover {
  color: var(--el-color-primary) !important;
}

.index-tag::-webkit-scrollbar {
  display: none;
}

.home-content {
  width: 100%;
}
</style>
